"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_38_0_0 = void 0;
/**
 * Migrate to 38.0.0
 *
 * Article property WidenZeichnungId has changed from string to LocalizedText [EKE-4269]
 *
 */
const migration_38_0_0 = (json) => {
    if (json.Kette) {
        if (typeof json.Kette.WidenZeichnungId === 'string') {
            json.Kette.WidenZeichnungId = { 'de-DE': json.Kette.WidenZeichnungId };
        }
    }
    if (json.AEs) {
        json.AEs.map((ae) => {
            {
                if (typeof ae.WidenZeichnungId === 'string') {
                    ae.WidenZeichnungId = { 'de-DE': ae.WidenZeichnungId };
                }
            }
        });
    }
    if (json.Fuehrungsrinnen) {
        json.Fuehrungsrinnen.map((f) => {
            {
                if (typeof f.WidenZeichnungId === 'string') {
                    f.WidenZeichnungId = { 'de-DE': f.WidenZeichnungId };
                }
            }
        });
    }
    return json;
};
exports.migration_38_0_0 = migration_38_0_0;
//# sourceMappingURL=migration_38_0_0.js.map